/**
 * Utility to parse lesson markdown into distinct sections (Intro, Part 1, Part 2..., Summary/Conclusion)
 */
export function parseLessonSections(markdown, metadataParts = []) {
  if (!markdown) {
    return {
      intro: '',
      sections: [],
      summary: '',
      isMultiPart: false,
    };
  }

  const lines = markdown.split('\n');
  const partMap = {};
  let introLines = [];
  let summaryLines = [];
  let currentPartNo = null;
  let isAfterLastPart = false;

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    const trimmed = line.trim();

    // Level 2 Heading: `## `
    if (trimmed.startsWith('## ')) {
      const heading = trimmed.replace(/^##\s+/, '').trim();
      const matchPart = heading.match(/^phần\s*(\d+)(?:[.:—\s]+(.*))?/i);
      const isSummaryHeading = /^(tóm tắt|tổng kết|bài tập bắt buộc|tài liệu tải về|học tiếp)/i.test(heading);

      if (matchPart) {
        currentPartNo = parseInt(matchPart[1], 10);
        isAfterLastPart = false;
        if (!partMap[currentPartNo]) {
          partMap[currentPartNo] = {
            no: currentPartNo,
            title: matchPart[2]?.trim() || `Phần ${currentPartNo}`,
            lines: [],
          };
        }
        partMap[currentPartNo].lines.push(line);
        continue;
      } else if (isSummaryHeading && currentPartNo !== null) {
        isAfterLastPart = true;
        summaryLines.push(line);
        continue;
      }
    }

    if (isAfterLastPart) {
      summaryLines.push(line);
    } else if (currentPartNo !== null) {
      partMap[currentPartNo].lines.push(line);
    } else {
      introLines.push(line);
    }
  }

  const partNumbers = Object.keys(partMap).map(Number).sort((a, b) => a - b);
  const isMultiPart = partNumbers.length >= 2;

  const sections = partNumbers.map((no) => {
    const p = partMap[no];
    const metaMatch = metadataParts.find((mp) => mp.no === no);
    return {
      no: no,
      title: metaMatch?.title || p.title,
      content: p.lines.join('\n').trim(),
    };
  });

  return {
    intro: introLines.join('\n').trim(),
    sections: sections,
    summary: summaryLines.join('\n').trim(),
    isMultiPart: isMultiPart,
  };
}
